import { render } from "./UpdateHistoryModal.vue?vue&type=template&id=6145b3bc&scoped=true&ts=true"
import script from "./UpdateHistoryModal.vue?vue&type=script&lang=ts"
export * from "./UpdateHistoryModal.vue?vue&type=script&lang=ts"

import "./UpdateHistoryModal.vue?vue&type=style&index=0&id=6145b3bc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6145b3bc"]])

export default __exports__